// Stok sayım ekran yetkileri. Admin/alt admin için hepsi açık; şube yöneticisi için
// managerPanel ayarlarındaki stock_count ve stock_count_subPermissions kullanılır.
// Kural backend'deki ManagerPanelPermissions.IsGranted(stock_count_*) ile aynıdır;
// ekran yalnız butonları gizler, asıl denetim sunucudadır.

export interface StockCountUiPermissions {
  canView: boolean;
  /** Sayım oluşturma, planlama, atama, başlatma, iptal. */
  canCreate: boolean;
  /** Atanmadığı sayımlarda da okutma / elle giriş. */
  canCount: boolean;
  /** Hızlı sayım açıp sayma. */
  canQuick: boolean;
  /** İnceleme, yeniden saydırma, onaylayıp stoğa işleme. */
  canApprove: boolean;
}

export const FULL_STOCK_COUNT_PERMISSIONS: StockCountUiPermissions = {
  canView: true,
  canCreate: true,
  canCount: true,
  canQuick: true,
  canApprove: true,
};

export const resolveStockCountPermissions = (settings: any): StockCountUiPermissions => {
  const source = settings || {};
  const subs = source.stock_count_subPermissions || {};
  const open = source.stock_count === true;
  return {
    canView: open,
    canCreate: open && subs.stock_count_create === true,
    canCount: open && subs.stock_count_count === true,
    canQuick: open && subs.stock_count_quick === true,
    canApprove: open && subs.stock_count_approve === true,
  };
};
